import React from 'react';
import PropTypes from 'prop-types';
import { IoMdInformationCircleOutline } from 'react-icons/io';

const ExerciseIndicator = ({ steps, exerciseNumber, setDisplayInstructions }) => (
  <>
    <div className="exercises__steps">
      {steps.map(({ stepNumber }) => (
        <div
          key={stepNumber}
          className={`exercises__steps_current ${stepNumber === exerciseNumber ? 'current' : ''}`}
        />
      ))}
    </div>
    <div className="exercises__instructionsicon">
      <IoMdInformationCircleOutline onClick={setDisplayInstructions} />
    </div>
  </>
);

ExerciseIndicator.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.number).isRequired,
  exerciseNumber: PropTypes.number.isRequired,
  setDisplayInstructions: PropTypes.func.isRequired,
};

export default ExerciseIndicator;
